module.exports = __webpack_public_path__ + "media/images/pic/godzilla-mobile-a6f9ccccde9f8e86c0edb416f0d82813.webp";